// extracted by mini-css-extract-plugin
export default {"bookNowBtn":"BookNowBtn_bookNowBtn__8058U","change-color-on-hover":"BookNowBtn_change-color-on-hover__ysEDu","button":"BookNowBtn_button__pa2-B"};